import React from 'react';
import { Calendar, Eye, Clock, Heart, Gamepad2 } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Bonuses() {
  const bonuses = [{
    icon: <Calendar className="w-7 h-7 text-sage-dark" data-id="element-58" />,
    title: 'BONO 1: Calendario de actividades',
    desc: 'Organización simple para cada día.',
    color: 'bg-sage'
  }, {
    icon: <Gamepad2 className="w-7 h-7 text-gold-hover" data-id="element-59" />,
    title: 'BONO 2: 30 ideas sin pantallas',
    desc: 'Juegos divertidos para desconectar.',
    color: 'bg-gold'
  }, {
    icon: <Eye className="w-7 h-7 text-sage-dark" data-id="element-60" />,
    title: '🎁 BONO 3: Estimulación visual para recién nacidos',
    desc: 'Guía práctica con tarjetas visuales en blanco y negro para estimular el desarrollo visual y cognitivo desde los primeros meses. Incluye patrones de alto contraste, estimulación visual temprana, actividades suaves y simples, y uso recomendado por etapas.',
    color: 'bg-sage'
  }, {
    icon: <Clock className="w-7 h-7 text-gold-hover" data-id="element-61" />,
    title: 'BONO 4: Guía rápida para estimular sin agotarte',
    desc: 'Tips para mamás con poco tiempo.',
    color: 'bg-gold'
  }, {
    icon: <Heart className="w-7 h-7 text-sage-dark" data-id="element-62" />,
    title: 'BONO 5: Rutinas reales según edad',
    desc: 'Estructuras flexibles que se adaptan a vos.',
    color: 'bg-sage'
  }];
  return <div className="bg-cream" data-id="element-63">
      <Section data-id="element-64">
        <SectionTitle data-id="element-65">
          Hoy también te llevás todos estos bonos GRATIS
        </SectionTitle>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12" data-id="element-66">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-67">
              <div className={`absolute top-0 left-0 w-full h-2 ${bonus.color}`} data-id="element-68"></div>
              <div className={`${bonus.color === 'bg-sage' ? 'bg-sage-light/30' : 'bg-gold-light/50'} w-14 h-14 rounded-xl flex items-center justify-center mb-6`} data-id="element-69">
                {bonus.icon}
              </div>
              <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-70">
                {bonus.title}
              </h3>
              <p className="text-charcoal-light mb-6" data-id="element-71">{bonus.desc}</p>
              <span className="inline-block bg-cta/10 text-cta text-sm font-bold px-3 py-1 rounded-full" data-id="element-72">
                Incluido GRATIS hoy
              </span>
            </div>)}
        </div>
      </Section>
    </div>;
}